import { Action } from "../../../entity/Action";
import { CollectionType } from "../../../entity/CollectionType";
import { Method, ROUTES } from "../../configuration/Configuration";
import { fetchAPI } from "../../configuration/MainService";
import { ActionDto } from "../../dto/Action.dto";
import { CollectionTypeDto } from "../../dto/CollectionType.Dto";
import { mapActionDtoToAction } from "../../mapper/ActionMapper";
import { collectionActionTypeMapper } from "../../mapper/ActionTypeMapper";

class WSCollectionType {
  private static instance: WSCollectionType;

  private constructor() {}

  static getInstance(): WSCollectionType {
    if (!this.instance) {
      this.instance = new WSCollectionType();
    }
    return this.instance;
  }

  async getCollectionTypes() {
    try {
      const url = ROUTES.COLLECTION_TYPES;
    } catch (error) {}
  }

  async getActions(): Promise<Action[]> {
    try {
      const url = ROUTES.ACTIONS;
      const response = await fetchAPI<ActionDto[]>({
        url: url,
        method: Method.GET,
        isAuthenticated: true,
      });
      return mapActionDtoToAction(response.data);
    } catch (error) {
      throw error;
    }
  }

  async createAction(name: string, description: string) {
    try {
      const url = ROUTES.ACTIONS + ROUTES.CREATE;
      const response = await fetchAPI<string>({
        url: url,
        method: Method.POST,
        isAuthenticated: true,
        params: {
          name,
          description,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async createCollectionType(
    collectionId: string,
    actionId: string,
    companyId: string,
  ) {
    try {
      const url = ROUTES.COLLECTION_TYPES + ROUTES.CREATE;
      const response = await fetchAPI<string>({
        url: url,
        method: Method.POST,
        isAuthenticated: true,
        params: {
          collectionId,
          actionId,
          companyId,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getCollectionTypesByCompanyId(
    companyId: string,
  ): Promise<CollectionType[]> {
    try {
      const url =
        ROUTES.COLLECTION_TYPES + ROUTES.GET_BY_COMPANY_ID + companyId;
      const response = await fetchAPI<CollectionTypeDto[]>({
        url: url,
        method: Method.GET,
        isAuthenticated: true,
      });
      return collectionActionTypeMapper(response.data);
    } catch (error) {
      throw error;
    }
  }
}

export const WSCollectionTypeInstance = WSCollectionType.getInstance();
